<template>
	<div class="marquee-container" :class="`marquee-container_theme-${theme}`">
		<div class="marquee-content">
			<span class="marquee-text" v-for="(item, index) in doubledContent" :key="index">{{ item }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaywallMarquee',

	props: {
		duration: {
			type: Number,
			default: 16,
		},

		content: {
			type: Array,
			required: true,
		},

		theme: {
			type: String,
			default: 'default',
			validator: (value) => ['default', 'purple', 'orange'].includes(value),
		},
	},

	computed: {
		doubledContent() {
			return this.content.concat(this.content)
		},
	},
}
</script>

<style scoped lang="scss">
.marquee-container {
	margin-left: -20px;
	margin-right: -20px;
	overflow: hidden;
	white-space: nowrap;
	position: relative;
	background-color: var(--Fill-Green-100);
	color: var(--Text-White-100);
	font-size: var(--size-14);
	line-height: var(--size-22);
	padding: var(--size-4) 0;
	font-weight: 600;

	&:after,
	&:before {
		content: '';
		position: absolute;
		display: block;
		top: 0;
		height: 100%;
		width: 32px;
		z-index: 1;
	}

	&:after {
		right: 0;
		background: linear-gradient(270deg, #38af76 0%, rgba(56, 175, 118, 0) 100%);
	}

	&:before {
		left: 0;
		background: linear-gradient(270deg, rgba(56, 175, 118, 0) 0%, #38af76 100%);
	}

	&.marquee-container_theme-purple {
		background-color: #b47aff;

		&:after,
		&:before {
			content: none;
		}

		.marquee-text {
			font-weight: 700;
			&:after {
				content: none;
			}
		}
	}

	&.marquee-container_theme-orange {
		background-color: #ffa435;

		&:after,
		&:before {
			content: none;
		}

		.marquee-text {
			font-weight: 700;
			&:after {
				content: none;
			}
		}
	}
}

.marquee-content {
	display: flex;
	width: max-content;
	animation: marquee linear infinite;
	animation-duration: v-bind("duration + 's'");
}

.marquee-text {
	padding-right: var(--size-10);

	&:after {
		content: '•';
		margin-left: var(--size-10);
	}
}

@keyframes marquee {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(-50%);
	}
}
</style>
